import React from 'react';

const testimonials = [
  {
    name: 'Rajesh Kumar',
    role: 'CEO, TechCorp India',
    initials: 'RK',
    text: 'NexGen handled our annual corporate event flawlessly. Their attention to detail and creative approach made it the best event we have ever had. Highly recommended!',
    stars: 5,
  },
  {
    name: 'Priya Sharma',
    role: 'Director, GovTech Solutions',
    initials: 'PS',
    text: 'As a government stationery supplier, they are always reliable and deliver quality products on time. Their GeM portal expertise makes procurement hassle-free.',
    stars: 5,
  },
  {
    name: 'Amit Patel',
    role: 'Founder, StartUp Hub',
    initials: 'AP',
    text: 'Their software development team built an amazing web application for us. The graphic design work for our branding was equally impressive. A true one-stop solution!',
    stars: 5,
  },
];

const Testimonials = () => {
  return (
    <section className="testimonials" id="testimonials">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Testimonials</span>
          <h2>What Our Clients Say</h2>
          <p>
            Do not just take our word for it. Here is what our valued clients
            have to say about working with us.
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div className="testimonial-card" key={index}>
              <div className="testimonial-quote">"</div>
              <div className="testimonial-stars">
                {'★'.repeat(testimonial.stars)}
              </div>
              <p>{testimonial.text}</p>
              <div className="testimonial-author">
                <div className="testimonial-avatar">
                  {testimonial.initials}
                </div>
                <div className="testimonial-info">
                  <h4>{testimonial.name}</h4>
                  <span>{testimonial.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;